import {
  styled,
  AccordionProps,
  Accordion as MuiAccordion,
  AccordionSummary as MUIAccordionSummary,
} from '@mui/material';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
  margin: 0,
  alignItems: 'center',
  // width: 'min-content',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled(MUIAccordionSummary)(props => ({
  padding: 0,
  minHeight: 'min-content',
  justifyContent: 'flex-start',
  '.MuiAccordionSummary-content': {
    display: 'contents',
    padding: 0,
    margin: 0,
  },
}));

export default Accordion;
export {AccordionSummary};
